  async function loadCompareProducts(sectionElement, selector, section) {
    
     const items = new Set(JSON.parse(localStorage.getItem("theme:compared-products") || "[]"));
     const _searchQueryString =   Array.from(items.values(), (item) => `id:${item}`).join(" OR ");

      const url = `${Shopify.routes.root}search?type=product&q=${_searchQueryString}&section_id=${sectionElement}`,
        response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"),
     selectorProductsElement = tempDiv.querySelector(selector);
  if (selectorProductsElement?.childElementCount > 0) {
    section.replaceChildren(...document.importNode(selectorProductsElement, true).childNodes);
  if(typeof StampedFn == "object") {
    StampedFn?.reloadUGC();
  }
    
  } else {
    section.innerHTML = "";
  }

    const itemsSize = items.size;
    
    if(document.querySelector('compare-products-drawer')) {
      document.querySelector('compare-products-drawer').dataset.productsCount = items.size;
      if(itemsSize > 3) {
        document.querySelector('compare-products-drawer').classList.add("scrollable-drawer");
      } else {
        document.querySelector('compare-products-drawer').classList.remove("scrollable-drawer");
      }
      
    }
   

    return tempDiv;
   
  }
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

function handleDrawerCompareButton($this) {

       
        const compareProductsPopup = document.querySelector("compare-products-popup");
        if(compareProductsPopup){
          $this.setAttribute('aria-busy', true);
          compareProductsPopup.loadCompareProducts();
          $this.removeAttribute("aria-busy");
      
        }
}
async function handlCompareClear($this) {
  
    const compareProductsDrawer = document.querySelector("compare-products-drawer");
    if(compareProductsDrawer){

      $this.setAttribute('aria-busy', true);
      localStorage.setItem('theme:compared-products', JSON.stringify([]));
      document.querySelectorAll("compare-product-button")?.forEach(item => item.classList.remove("added-to-compare"));
      await  compareProductsDrawer.loadCompareProducts();
      $this.removeAttribute("aria-busy");
  
    }
}

function handleDrawerSearchItem($this) {
   const productId = parseInt($this.dataset.productId, 10);

     let $compareProductButton = document.querySelector(`.compare-product-button[data-product-id="${productId}"]`);
     let comparedProducts = getCompareProducts();
  
   let compareProductsLimit = parseInt(document.querySelector('body').dataset.compareProductsLimit, 10);

    if(comparedProducts.length < compareProductsLimit) {

       comparedProducts.push(productId);
       localStorage.setItem('theme:compared-products', JSON.stringify(comparedProducts));
      if(document.querySelector("compare-products-drawer")){
    document.querySelector("compare-products-drawer").loadCompareProducts();
    }

      if($compareProductButton) {
         $compareProductButton.classList.add('added-to-compare');
      }
    } else {
        document.querySelector(".compare-products-error-popup").querySelector("modal-content").open = true;
    return;
    }

}

async function handleDrawerSearch($this) {

   const query = $this.value.trim();
  let compareSearchResults = document.querySelector('.compare-search-results');
      const url = `${Shopify.routes.root}search?type=product&q=${query}&section_id=compare-search-products`,
        response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"),
     selectorProductsElement = tempDiv.querySelector(".product-list-inner");
  if (selectorProductsElement?.childElementCount > 0) {
    compareSearchResults.replaceChildren(...document.importNode(selectorProductsElement, true).childNodes);
 
} else {
    compareSearchResults.innerHTML = "";
}
}
function handleRemoveCompareItem($this) {

  const $productItem = $this.closest("[data-product-item]");
  const productId = parseInt($productItem.dataset.productId, 10);

  let comparedProducts =  getCompareProducts();
  const newItems = comparedProducts.filter(item => item !== productId);

  localStorage.setItem('theme:compared-products', JSON.stringify(newItems));

  let compareProductButton = document.querySelector(`compare-product-button[data-product-id="${productId}"]`);

  if(compareProductButton){
    compareProductButton.classList.remove("added-to-compare");
  }

  $productItem.remove();
 if(document.querySelector("compare-products-drawer")){
    document.querySelector("compare-products-drawer").loadCompareProducts();
  }

   let updatedComparedProducts =  getCompareProducts();
  if(updatedComparedProducts.length < 2) {
      if (document.querySelector('compare-products-popup')?.querySelector("compare-products-modal-content")) {
    document.querySelector('compare-products-popup').querySelector("compare-products-modal-content").open = false;
  }
  }
}
function getCompareProducts() {
   
   let comparedProducts = [...new Set(JSON.parse(localStorage.getItem("theme:compared-products") || "[]"))];
   
   return comparedProducts;

}
var CompareProductButton = class extends HTMLElement {
  constructor() {
    super();

  }

  handleClick(event) {

    event.preventDefault();
    event.stopPropagation();

    let comparedProducts = getCompareProducts();
    if((comparedProducts.length >= this.compareProductsLimit) && !this.classList.contains('added-to-compare')) {
    
    document.querySelector(".compare-products-error-popup").querySelector("modal-content").open = true;
    return;
    }
    
    if(this.classList.contains('added-to-compare')) {
    this.classList.remove('added-to-compare');
    let productIndexToRemove = comparedProducts.indexOf(this.productId);
    if(productIndexToRemove > -1) {
    comparedProducts.splice(productIndexToRemove, 1);
    }
    
    } else {
    comparedProducts.push(this.productId);
    
    this.classList.add('added-to-compare');
    }
    localStorage.setItem('theme:compared-products', JSON.stringify(comparedProducts));
    
    if(document.querySelector("compare-products-drawer")){
    document.querySelector("compare-products-drawer").loadCompareProducts();
    }
    
    this.handleCompareProducts();
  }
  handleCompareProducts() {
         let comparedProducts = getCompareProducts();

      if(comparedProducts.includes(this.productId)) {
      this.classList.add('added-to-compare');
    } 
  }
  connectedCallback() {

    const comparedProducts = getCompareProducts();
    const productsCount = comparedProducts.length;
    this.productId = parseInt(this.dataset.productId, 10);
    this.handleClick = this.handleClick.bind(this);

    this.closest('.boost-sd__product-item')?.classList.toggle("show-compare-button", (productsCount !== 0));
    this.compareProductsLimit = parseInt(document.querySelector('body').dataset.compareProductsLimit, 10);
            
    this.handleCompareProducts();
    this.addEventListener('click', this.handleClick);
  }
  disconnectedCallback() {
     this.removeEventListener('click', this.handleClick);
  }

}

if (!window.customElements.get("compare-product-button")) {
  window.customElements.define("compare-product-button", CompareProductButton);
}

var CompareProductsPopup = class extends HTMLElement {
  constructor() {
    super();
  }

  async loadCompareProducts() {
   await loadCompareProducts("compare-products-popup", ".product-list", this);

    this.classList.add('popup-open');

    let compareModalContent = this.querySelector("compare-products-modal-content");
    
    if (compareModalContent && !compareModalContent.open) {

    compareModalContent.open = true;
    }
}
}

if (!window.customElements.get("compare-products-popup")) {
  window.customElements.define("compare-products-popup", CompareProductsPopup);
}
var CompareProductsDrawer = class extends HTMLElement {

  static get observedAttributes() {
  return ['data-products-count'];
}
  constructor() {
     
    super();
    this.compareButton = this.querySelector(".product-form__compare-button");

  }
   async connectedCallback() {

   await  this.loadCompareProducts();
  
  }
   disconnectedCallback() {
   
  }

  onProductsCountChange(productsCount) {

    productsCount = parseInt(productsCount, 10) || 0;

    const items = document.querySelectorAll("compare-product-button");

items.forEach(item => {
  item.closest('.boost-sd__product-item').classList.toggle("show-compare-button", (productsCount !== 0));
});

  }
  attributeChangedCallback(name, oldVal, newVal) {
  if (name === 'data-products-count') {
    this.onProductsCountChange(newVal);
  }
}
  async loadCompareProducts() {

    await loadCompareProducts("compare-products-drawer", ".product-list", this);
    const $container = this.closest(".compare-products-drawer");
    this.querySelector(".drawer-opener-button")?.addEventListener("click", function(event){

        const header = $container.querySelector('.compare-header');
        const productList = $container.querySelector('.product-list__wrapper');
        const isExpanded = $container.getAttribute('data-expanded') === 'true';
       // const totalHeight = $container.offsetHeight + header.offsetHeight;
       // const targetHeight = isExpanded ? header.offsetHeight : totalHeight;

      //  $container.style.height = `${targetHeight}px`;
      // $container.style.maxHeight = `${targetHeight}px`;
        $container.setAttribute('data-expanded', !isExpanded);
  
    });
}
}

if (!window.customElements.get("compare-products-drawer")) {
  window.customElements.define("compare-products-drawer", CompareProductsDrawer);
}

var CompareProductsModalContent = class extends OpenableElement {
    connectedCallback() {
        super.connectedCallback();
        this.delegate.on("click", ".modal__overlay", () => this.open = false);
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        switch (name) {
            case "open":
                document.documentElement.classList.toggle("lock-all", this.open);
                if (this.open) {
                    localStorage.setItem("theme:popup-appeared", true);
                }
        }
    }
};
window.customElements.define("compare-products-modal-content", CompareProductsModalContent);